import { supabase } from "@/integrations/supabase/client";

/**
 * Validates that a track is sponsored and returns track details
 */
export async function validateTrackSponsorship(
  trackId: string,
  artistId: string,
): Promise<{
  valid: boolean;
  track?: any;
  reason?: string;
}> {
  try {
    console.log(
      "📀 [TRACK_VALIDATOR] Fetching track details for sponsorship validation",
    );

    const { data: track, error: trackError } = await supabase
      .from("tracks")
      .select("is_sponsored, sponsor_id, title, artist_id, streams")
      .eq("id", trackId)
      .single();

    if (trackError || !track) {
      console.error("❌ [TRACK_VALIDATOR] Error fetching track details:", {
        trackError,
        trackId,
      });
      return { valid: false, reason: "Track not found" };
    }

    console.log("📀 [TRACK_VALIDATOR] Track details retrieved:", {
      trackId,
      title: track.title,
      is_sponsored: track.is_sponsored,
      sponsor_id: track.sponsor_id,
      track_artist_id: track.artist_id,
      provided_artist_id: artistId,
      current_streams: track.streams,
    });

    // Verify the artist ID matches the track's artist
    if (track.artist_id !== artistId) {
      console.error("❌ [TRACK_VALIDATOR] Artist ID mismatch:", {
        track_artist_id: track.artist_id,
        provided_artist_id: artistId,
      });
      return { valid: false, reason: "Artist ID mismatch" };
    }

    // Check if track is sponsored - this is the critical check
    if (!track.is_sponsored || !track.sponsor_id) {
      console.log("❌ [TRACK_VALIDATOR] Track is not sponsored:", {
        is_sponsored: track.is_sponsored,
        sponsor_id: track.sponsor_id,
        trackId,
        trackTitle: track.title,
      });
      return { valid: false, reason: "Track is not sponsored" };
    }

    console.log("✅ [TRACK_VALIDATOR] Track is sponsored, validation passed:", {
      trackId,
      sponsorId: track.sponsor_id,
    });

    return { valid: true, track };
  } catch (error) {
    console.error("🔥 [TRACK_VALIDATOR] Exception in track validation:", {
      error,
      errorMessage: error instanceof Error ? error.message : "Unknown error",
      trackId,
      artistId,
    });
    return { valid: false, reason: "System error during track validation" };
  }
}
